import { smallShadow, mediumShadow, largeShadow } from 'ui/theme';
import { CardBorderRadius, CardSize, CardVariant } from './types';

export const CARD_VARIANTS: Record<Uppercase<CardVariant>, CardVariant> = {
  DEFAULT: 'default',
};

export const CARD_BORDER_RADIUS: Record<Uppercase<CardBorderRadius>, CardBorderRadius> = {
  NONE: 'none',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
};

export const CARD_SIZES: Record<Uppercase<CardSize>, CardSize> = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const SHADOWS = {
  none: 'none',
  subtle: smallShadow,
  small: mediumShadow,
  medium: mediumShadow,
  large: largeShadow,
};
